/* --------------------------------------------------
Import modules
-------------------------------------------------- */
import LazyLoad from '@meteora-digital/lazy';
/* --------------------------------------------------
Lazy Load Images
-------------------------------------------------- */
// Set up a lazy loader (uses data-src for image urls);

window.Lazy = new LazyLoad({
  offset: 500
}); // Lazy load elements with this selector

window.Lazy.watch('[data-src]');